import { useSearchParams } from 'react-router-dom';

import BusinessQuote from './Partials/MyBusinessQuote';
import PersonalQuote from './Partials/MyPersonalQuote';

const MyQuote = () => {
    const [searchParams] = useSearchParams();
    const isPersonalInsurance = searchParams.get('personal') === 'true';
    return <>{isPersonalInsurance ? <PersonalQuote /> : <BusinessQuote />}</>;
};

export default MyQuote;
